export default __webpack_public_path__ + "static/media/mobile-voter.59eeb825.webp";